import React from 'react';
import styled from 'styled-components';
import { SvgComponent, UserIcon } from '../../../assets';
import { theme } from '../../../theme';
import { BodyText } from '../../typography';

const Content = styled.header`
  display: flex;
  flex-direction: row;
  margin-right: ${theme.spacings[4].rem};
`;

const IconWrapper = styled.figure`
  margin: 0 ${theme.spacings[2].rem} 0 0;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const iconSizes = {
  small: 28,
  large: 48,
};

export type ContactCardIconSize = 'small' | 'large';

export type ContactCardContentProps = {
  title: string;
  subtitle: string;
  icon?: SvgComponent;
  iconSize?: ContactCardIconSize;
};
export const ContactCardContent: React.FC<ContactCardContentProps> = ({
  title,
  subtitle,
  icon: Icon = UserIcon,
  iconSize = 'large',
}) => {
  const iconSizing = iconSizes[iconSize];

  return (
    <Content>
      <IconWrapper>
        <Icon
          width={iconSizing}
          height={iconSizing}
          fill={theme.colors.neutrals.solidGrays[1]}
        />
      </IconWrapper>
      <TitleContainer>
        <BodyText size="lg">
          <b>{title}</b>
        </BodyText>
        <BodyText size="sm" color={theme.colors.neutrals.transparentGrays[2]}>
          {subtitle}
        </BodyText>
      </TitleContainer>
    </Content>
  );
};
